var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20B26C",
    fillOpacity: 0.16,
    d: "M23 5.751c-9.528 0-17.25 7.723-17.25 17.25s7.722 17.25 17.25 17.25c9.526 0 17.25-7.723 17.25-17.25S32.525 5.751 23 5.751M1.915 23.001c0-11.644 9.44-21.083 21.083-21.083 11.644 0 21.084 9.44 21.084 21.083 0 11.644-9.44 21.084-21.084 21.084S1.916 34.645 1.916 23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22.999,
    r: 21.083,
    fill: "#20B26C",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#20B26C",
    d: "M32.963 16.835c.758.74.773 1.953.034 2.71l-11.2 11.487c-.74.76-1.953.782-2.72.05l-6.024-5.736a1.917 1.917 0 0 1 2.643-2.776l4.666 4.443 9.89-10.143a1.917 1.917 0 0 1 2.71-.035"
  })));
};
export default SvgCheck;